module.exports = __webpack_public_path__ + "static/media/tut-3.e560849c.png";